import MileageDownloadAllCSVResponse from "../../../api/raily/mileage/download-all-csv/mileage-download-all-csv.response";
import MileageDownloadAllCSV from "./mileage-download-all-csv";

const create = (
  response: MileageDownloadAllCSVResponse,
): MileageDownloadAllCSV => {
  const data = response.data;

  return {
    data: data.data,
    filename: data.filename,
  };
};

const mileageDownloadAllCSVFactory = {
  create,
};

export default mileageDownloadAllCSVFactory;
